import {
    REQUEST_GENERATEDMESSAGE_DATA,
    RECEIVE_GENERATEDMESSAGE_DATA,
    REQUEST_DOWNLOAD_FILE,
    RECEIVE_DOWNLOAD_FILE
} from '../../constants/action_types';

export const GetGeneratedMessageReducers = (state = [], action = null) => {
    switch (action.type) {
        case REQUEST_GENERATEDMESSAGE_DATA:
            return {
                ...state
            };
        case RECEIVE_GENERATEDMESSAGE_DATA:
            return {
                ...state,
                GeneratedMessages: action.result.generatedMessages,
                Shift: action.result.shift,
                PageSize: action.result.pageSize,
                CurrentRecords: action.result.currentRecords,
                TotalRecords: action.result.totalRecords,
                endIndex: action.result.shift * action.result.pageSize + action.result.currentRecords,
                startIndex: action.result.totalRecords > 0 ? (1 + action.result.shift * action.result.pageSize) : 0,
                sortingOrder: action.result.sortingOrder,
                sortedColumnName: action.result.sortedColumnName
            };
        case REQUEST_DOWNLOAD_FILE:
            return {
                ...state,
                downloadResult: []

            };
        case RECEIVE_DOWNLOAD_FILE:
            return {
                ...state,
                downloadResult: action.result
            };
        default:
            return state;
    }
};
